import Image from 'next/image';
import LazyLoad from 'react-lazyload';
import { Box, Container, Grid, Typography } from '@mui/material';
import { useStyles } from './styles';

export default function TopInstitutions() {
  const classes = useStyles();

  return (
    <Box pt={5} pb={6} position="relative">
      <Container>
        <LazyLoad>
          <Typography component="h2" className={classes.title}>
            <span>100+ top institutions</span> already asked for their custom and compelling science
            designs
          </Typography>

          <Box px={4}>
            <Grid container spacing={4} justifyContent="center" alignItems="center">
              <Grid item xs={6} sm={2}>
                <Box display="flex" justifyContent="center">
                  <Image
                    src="/images/custom-services/abbott-logo.webp"
                    width={162}
                    height={41}
                    alt="Abbott logo"
                    loading="lazy"
                  />
                </Box>
              </Grid>

              <Grid item xs={6} sm={2}>
                <Box display="flex" justifyContent="center"></Box>
                <Image
                  src="/images/custom-services/edanz-logo.webp"
                  width={183}
                  height={66}
                  alt="Edanz logo"
                  loading="lazy"
                />
              </Grid>

              <Grid item xs={6} sm={2}>
                <Box display="flex" justifyContent="center">
                  <Image
                    src="/images/custom-services/bayer-logo.webp"
                    width={67}
                    height={66}
                    alt="Bayer logo"
                    loading="lazy"
                  />
                </Box>
              </Grid>

              <Grid item xs={6} sm={2}>
                <Box display="flex" justifyContent="center">
                  <Image
                    src="/images/custom-services/nestle-logo.webp"
                    width={166}
                    height={48}
                    alt="Nestle logo"
                    loading="lazy"
                  />
                </Box>
              </Grid>

              <Grid item xs={6} sm={2}>
                <Box display="flex" justifyContent="center">
                  <Image
                    src="/images/custom-services/sanofi-logo.webp"
                    width={135}
                    height={35}
                    alt="Sanofi logo"
                    loading="lazy"
                  />
                </Box>
              </Grid>

              <Grid item xs={6} sm={2}>
                <Box display="flex" justifyContent="center">
                  <Image
                    src="/images/custom-services/viatris-logo.webp"
                    width={141}
                    height={39}
                    alt="Viatris logo"
                    loading="lazy"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ display: { md: 'block', xs: 'none' } }}>
            <Box className={classes.logoReact}>
              <img
                src="/images/custom-services/logo-react.svg"
                width={166}
                height={148}
                alt="React logo"
                loading="lazy"
              />
            </Box>
          </Box>
        </LazyLoad>
      </Container>
    </Box>
  );
}
